if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      }

      connectedCallback() {
      // Delay Flickity so Dawn finishes layout first
      requestAnimationFrame(() => {
        this.initFlickity();
        this.fixFlickityAfterZoom();
      });
        this.handleResize = debounce(this.onResize.bind(this), 200);
        window.addEventListener('resize', this.handleResize);

      }

      // onSlideChanged(event) {
      //   const thumbnail = this.elements.thumbnails.querySelector(
      //     `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      //   );
       
      //   this.setActiveThumbnail(thumbnail);
      // }
      onSlideChanged(event) {
        const currentEl = event.detail?.currentElement;
        if (!currentEl?.dataset?.mediaId) return;

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${currentEl.dataset.mediaId}"]`
        );

        if (thumbnail) this.setActiveThumbnail(thumbnail);
     }


      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          //element.classList.remove('is-selected');
        });
        activeMedia?.classList?.add('is-active');
        //activeMedia.classList.add('is-selected');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

    initFlickity() {
      const main = this.querySelector('[data-flickity-main]');
      const nav = this.querySelector('[data-flickity-nav]');
      if (!main || typeof Flickity === 'undefined') return;

      if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityNav?.destroy();
      }

      this.flickityInstance = new Flickity(main, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
      });

      const overlays = this.querySelectorAll('.media-gallery-overlay [data-direction]');
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', (event) => {
          if (event.target.closest('.product__media-icon')) return;
          const direction = overlay.dataset.direction;
          if (direction === 'prev') {
            this.flickityInstance.previous();
          } else if (direction === 'next') {
            this.flickityInstance.next();
          }
        });
      });

        const mainSlider = this.querySelector('[data-flickity-main]');
        if (mainSlider) {
          if (window.innerWidth > 549) {

            mainSlider.addEventListener('mousemove', (e) => {
              const rect = mainSlider.getBoundingClientRect();
              const zoomHeight = 50; // height from bottom where zoom icon is
              const cursorActiveHeight = rect.height - zoomHeight;

              const yRelative = e.clientY - rect.top;

              // Only show cursor if above zoom icon area
              if (yRelative > cursorActiveHeight) {
                mainSlider.classList.remove('cursor-left', 'cursor-right');
                return;
              }

              const half = rect.width / 2;
              if (e.clientX - rect.left < half) {
                mainSlider.classList.add('cursor-left');
                mainSlider.classList.remove('cursor-right');
              } else {
                mainSlider.classList.add('cursor-right');
                mainSlider.classList.remove('cursor-left');
              }
            });


            mainSlider.addEventListener('mouseleave', () => {
              mainSlider.classList.remove('cursor-left', 'cursor-right');
            });

            mainSlider.addEventListener('click', (e) => {
                if (e.target.closest('.product__media-icon')) return;
            if (e.target.closest('.overlay-left') || e.target.closest('.overlay-right')) return;
            
              const rect = mainSlider.getBoundingClientRect();
              if (e.clientX - rect.left < rect.width / 2) {
                this.flickityInstance.previous();
              } else {
                this.flickityInstance.next();
              }
            });
          }
        }



      if (nav) {
        this.flickityNav = new Flickity(nav, {
          asNavFor: main,
          contain: true,
          pageDots: false,
          prevNextButtons: false
        });
      }

      this.flickityInstance.on('change', (index) => {
        const cell = this.flickityInstance.cells[index]?.element;
        if (!cell?.dataset?.mediaId) return;

        const thumb = this.elements.thumbnails?.querySelector(
          `[data-target="${cell.dataset.mediaId}"]`
        );
        if (thumb) this.setActiveThumbnail(thumb);
      });
    }

    // fixFlickityAfterZoom() {
    //   const modal = document.querySelector('.product-media-modal');
    //   if (!modal) return;

    //   const observer = new MutationObserver(() => {
    //     if (!modal.hasAttribute('open')) {
    //       if (!this.flickityInstance) return;

    //       const savedIndex = this.flickityInstance.selectedIndex;

    //       // Use double requestAnimationFrame to ensure DOM updated
    //       requestAnimationFrame(() => {
    //         requestAnimationFrame(() => {
    //           // Deactivate and reactivate Flickity to force full layout recalculation
    //           this.flickityInstance.deactivate();
    //           this.flickityInstance.activate();

    //           // Restore saved slide index (no animation)
    //           this.flickityInstance.select(savedIndex, false, true);

    //           // Resize & reposition for layout fix
    //           this.flickityInstance.resize();
    //           this.flickityInstance.reposition();

    //           // Optional: Scroll to top of active slide container smoothly to avoid jump
    //           const activeSlide = this.flickityInstance.selectedElement;
    //           if (activeSlide) {
    //             const rect = activeSlide.getBoundingClientRect();
    //             if (rect.top < 0) {
    //               window.scrollTo({ top: window.scrollY + rect.top, behavior: 'smooth' });
    //             }
    //           }
    //         });
    //       });
    //     }
    //   });
    //   observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    // }
    fixFlickityAfterZoom() {
  const modal = document.querySelector('.product-media-modal');
  if (!modal) return;

  let savedIndex = null;

  const observer = new MutationObserver(() => {
    if (modal.hasAttribute('open')) {
      // Save the current index when modal is opened
      savedIndex = this.flickityInstance.selectedIndex;
    } else {
      // On modal close, restore the saved slide index
      if (this.flickityInstance && savedIndex !== null) {
        // Simply restore the slide index without deactivating or reactivating Flickity
        this.flickityInstance.select(savedIndex, false, true);  // 'false' for no animation
      }
    }
  });

  observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
}
  

      destroyFlickity() {
        if (this.flickityInstance) {
          this.flickityInstance.destroy();
          this.flickityInstance = null;
        }

        if (this.flickityNav) {
          this.flickityNav.destroy();
          this.flickityNav = null;
        }
      }
      onResize() {
        if (!this.elements.viewer) return;

        this.destroyFlickity();

        requestAnimationFrame(() => {
          this.initFlickity();
        });
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
